// extracted by mini-css-extract-plugin
module.exports = {"platform_layout":"index-module__platform_layout___s0KPo"};